/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useLocation } from 'react-router-dom';

interface PrimarySlugStatus {
  isLivePrimarySlug: boolean;
  isIndyPrimarySlug: boolean;
  isTnsPrimarySlug: boolean;
  isCombinedViewPrimarySlug: boolean;
}

export const usePrimarySlugStatus = (): PrimarySlugStatus => {
  const location = useLocation();
  const currentSlug = location.pathname.toLowerCase();
  // check the split path. If it's 2, it's just /live or /indy.
  // If it's 3, it's /live/:workspaceSlug or /indy/:workspaceSlug so we need to check if the second path is live or indy
  const splitPath = currentSlug.split('/');
  const isLivePrimarySlug =
    splitPath.length === 2 ? currentSlug?.includes('/live') : splitPath.length === 3 ? splitPath[1] === 'live' : false;
  const isIndyPrimarySlug =
    splitPath.length === 2 ? currentSlug?.includes('/indy') : splitPath.length === 3 ? splitPath[1] === 'indy' : false;
  const isTnsPrimarySlug =
    splitPath.length === 2 ? currentSlug?.includes('/tns') : splitPath.length === 3 ? splitPath[1] === 'tns' : false;
  const isCombinedViewPrimarySlug =
    splitPath.length === 2
      ? currentSlug?.includes('/combined-view')
      : splitPath.length >= 3
      ? splitPath[1] === 'combined-view'
      : false;
  return {
    isLivePrimarySlug: isLivePrimarySlug,
    isIndyPrimarySlug: isIndyPrimarySlug,
    isTnsPrimarySlug: isTnsPrimarySlug,
    isCombinedViewPrimarySlug: isCombinedViewPrimarySlug,
  };
};
